import moment from "moment";
import { clearCache } from "../services/api";

type Props = {
  cachedTime?: string;
  cacheEntities: string;
  entityId: string;
  reloadWithForceRefresh?: boolean;
};

export default function CacheInfo({ cachedTime, cacheEntities, entityId, reloadWithForceRefresh }: Props) {
  if (!cachedTime) {
    return null;
  }

  const buildReloadUrl = () => {
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set("forceRefresh", "1");
    return currentUrl.toString();
  };

  const handleClearCache = async () => {
    await clearCache(cacheEntities, entityId);
    if (reloadWithForceRefresh) {
      window.location.assign(buildReloadUrl());
      return;
    }

    window.location.reload();
  };

  return (
    <div className="cache-info">
      <span>{`Data aktualni k: ${moment(cachedTime).format("DD.MM.YYYY HH:mm")}`}</span>
      <a href="javascript:void(0)" onClick={handleClearCache} className="cache-refresh">
        <i className="material-icons">refresh</i>
      </a>
    </div>
  );
}
